import { TInputParams } from 'entries/common/widgets/context';
import { ParametersEnum } from '../types';

type TProps = {
  inputParameters: TInputParams;
  hasLengthWidth: boolean;
  hasNotWallArea: boolean;
};

export const hasAreaInRoom = ({ inputParameters, hasLengthWidth, hasNotWallArea }: TProps) =>
  inputParameters.includes(ParametersEnum.area) && !hasNotWallArea && hasLengthWidth;
